/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'messenger': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data: '<g _fill="none" fill-rule="evenodd"><rect pid="0" _fill="#459AF5" width="35" height="35" rx="17.5"/><path pid="1" d="M15.055 25.308l-2.888 1.65v-3.143C10.236 22.288 9 19.95 9 17.329 9 12.729 12.806 9 17.5 9s8.5 3.729 8.5 8.329c0 4.6-3.806 8.328-8.5 8.328-.85 0-1.67-.122-2.445-.35z" _fill="#FFF"/><path pid="2" _fill="#459AF5" fill-rule="nonzero" d="M11.9 20.306l4.696-5.191 2.23 2.329 4.114-2.442-4.536 5.168-2.21-2.37z"/></g>'
  }
})
